module.exports = __webpack_public_path__ + "img/table.3213cf9f.png";